import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Product/ProductFacing/productFacing.container"
    ).then((module) => ({
        default: module.ProductFacingContainer
    }))
);
